import React from "react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../components/universal/navbar";
import Hero from "../components/universal/hero";
import Transformation from "../components/universal/transformation";
import SmilesStep from "../components/universal/smilesStep";
import Reviews from "../components/universal/reviews";
import ContactUs from "../components/universal/contactUs";
import Footer from "../components/universal/footer";
import Service from "../components/universal/service";
import FAQS from "../components/universal/faqs";
import InvisalignFix from "../components/universal/invisalign-fix";
import VerticalSlider from "../components/universal/steps";

import BackToTop from "../components/universal/back-to-top";
import { Helmet } from "react-helmet";

const App = () => {
  return (
    <>
      <Helmet>
        <title>
          Clear Aligners - Clinically Led Teeth Straightening | Alignar
        </title>
        <meta
          name="description"
          content="Discover clinically led teeth straightening solutions with Alignar clear aligners, featuring our multi-layered design to offer enhanced comfort."
        />
        <link rel="canonical" href="https://www.alignar.com/"></link>
      </Helmet>
      <div>
        <BackToTop />
        <Navbar />
        <Hero />
        <Service />
        <VerticalSlider />
        <Transformation />
        <InvisalignFix />
        <SmilesStep />
        <Reviews />
        <FAQS />
        <ContactUs />
        <Footer />
      </div>
    </>
  );
};

export default App;
